/**
 * Dev-only runtime assertion that throws if `render` is a function (callback
 * mode) instead of a ReactElement (element mode).
 *
 * Base UI's `useRender` supports both modes, but we restrict to element mode
 * to keep our API decoupled from the underlying library's internal state shape.
 * The TypeScript types already constrain `render` to `ReactElement`, but this
 * assertion catches misuse from `any` casts, and edge cases where types
 * are bypassed.
 *
 * Tree-shaken to zero bytes in production via the `process.env.NODE_ENV` guard.
 */
export function assertElementRender(componentName, render) {
  if (process.env.NODE_ENV !== 'production' && typeof render === 'function') {
    throw new Error(`${componentName}: \`render\` accepts a ReactElement, not a function. ` + 'Pass a JSX element like `render={<button />}` instead of a callback.');
  }
}